import { FC, HTMLAttributes, ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { Layout } from 'antd';
import cn from 'classnames';

import { AppDispatch } from 'app/appStore';
import { useAppConfigRetrieveQuery } from 'shared/api';
import { useMedia } from 'shared/hooks';
import { HeaderAdvertiser } from 'widgets/Header';
import { Sidebar } from 'widgets/Sidebar';

import styles from './Layout.module.scss';

interface ILayoutAdvertiserProps extends HTMLAttributes<HTMLDivElement> {
	outlet?: ReactNode;
}

export const LayoutAdvertiser: FC<ILayoutAdvertiserProps> = ({ className, outlet, ...props }) => {
	const isDesktop = useMedia('desktop');
	const { data: appConfig } = useAppConfigRetrieveQuery();
	const dispatch = useDispatch<AppDispatch>();
	// useGAInit();

	useEffect(() => {
		if (!appConfig?.user) {
			return;
		}
	}, [appConfig, dispatch]);

	return (
		<Layout {...props} className={cn(className, styles.main)}>
			{isDesktop && <Sidebar />}
			<Layout className={styles.layout}>
				<HeaderAdvertiser />
				<Layout.Content className={styles.content}>{outlet || <Outlet />}</Layout.Content>
				{/*<Footer />*/}
			</Layout>
		</Layout>
	);
};
